import * as v from "valibot";
import { useJsonReader } from "../../bridge/binary";
import { createProxies } from "./proxies";

export const CanvasConnectedClientSchema = v.object({
  connectionId: v.string(),
  isLocalUser: v.boolean(),
  userId: v.string(),
  email: v.string(),
  nickname: v.nullish(v.string()),
  profileImageUrl: v.nullish(v.string()),
  color: v.number(),
});

export type CanvasConnectedClient = v.InferOutput<typeof CanvasConnectedClientSchema>;

export interface ConnectedClientCursor {
  isVisible: boolean;
  mouseX: number;
  mouseY: number;
  isSelecting: boolean;
}

interface CollaborationExportsMethods {
  GetConnectedClients: (shortcut: string) => Promise<CanvasConnectedClient[]>;
  GetMouseStatus: (connectionId: string) => ConnectedClientCursor | undefined;
  ReconnectToEditor: () => Promise<void>;
}

export interface CollaborationExports {
  Collaboration: CollaborationExportsMethods;
}

const {
  setup,
  getConnectedClients: getConnectedClientsProxy,
  getMouseStatus: getMouseStatusProxy,
  reconnectToEditor,
} = createProxies<CollaborationExportsMethods>([
  "GetConnectedClients",
  "GetMouseStatus",
  "ReconnectToEditor",
]);

const getMouseStatus = useJsonReader(getMouseStatusProxy);
const getConnectedClients = useJsonReader(getConnectedClientsProxy);

export {
  getConnectedClients,
  getMouseStatus,
  reconnectToEditor,
  setup,
};
